const FULL_SELL_PRICE = 'full_sale_price'
const IS_REPACKED = 'is_repacked'

/**
 * class, that has been created in 12.10.2020 for handling cellRender prop of ag-grid library
 *
 * this class should contain any new cellRenderer, and, in hope, refactoring old code for this purpose here.
 */
export class CellRendererService {

  /**
   * function for adding a exclamatory mark in cell of progressBar ONLY for the purpose of showing popover
   * popovers for this functions are actually in SalesOrder.vue component just after the salesOrder ag-grid
   * this plain function is called from old renderHelpers.js file in FieldsRenderer function
   * @returns {function(*): string}
   */
  plainExclamatoryMark () {
    return (props) => {
      const id = props.data.id
      const is_repacked = props.data[IS_REPACKED]

      return `${is_repacked
          ? `<span id="salesOrderExclamatory${id}" class="sales_order_exclamatory__mark--in-progress">!</span>`
          : ''}`
    }
  }

  /**
   * function for adding a exclamatory mark in cell to its value for the purpose of showing popover
   * popovers for this functions are actually in SalesOrder.vue component just after the salesOrder ag-grid
   * @returns {function(*): string}
   */
  exclamatoryMark () {
    return (props) => {
      const id = props.data.id
      const renderValue = props.data[FULL_SELL_PRICE]
      const is_repacked = props.data[IS_REPACKED]

      return `
      <span class="sales_order_exclamatory">
        ${is_repacked
        ? `<span id="salesOrderExclamatory${id}" class="sales_order_exclamatory__mark">!</span>`
        : ''}
        <span 
          class="sales_order_exclamatory__text ${!is_repacked ? 'sales_order_exclamatory__text--no-mark' : ''}">
          ${renderValue}
        </span>
      </span>
      `
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/renderService.js